// Implements the v6 architecture doc §5.1 immediate-feedback standard: any
// tap that triggers a network call shows a specific, visible loading state
// immediately — never a frozen button with no visual change.

interface LoadingStateProps {
  label: string;
  fullScreen?: boolean;
}

export function LoadingState({ label, fullScreen }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={fullScreen ? 'flex min-h-screen w-full items-center justify-center bg-ink' : 'flex items-center gap-2 py-4'}
    >
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-gold-500 border-t-transparent" aria-hidden="true" />
      <span className="text-sm text-slate-400">{label}</span>
    </div>
  );
}
